/** @typedef {import('../types/auth').MerchantMetaData} MerchantMetaData */
/** @typedef {import('../types/api').ApiResponse} ApiResponse */

import { instance } from '../config/api';

/** @returns {Promise<ApiResponse<MerchantMetaData>>} */
const fetchMerchantKeys = async () => {
  const { data } = await instance.get('merchant/meta');
  return data;
};

/** @returns {Promise<ApiResponse<MerchantMetaData>>} */
const generateApiKey = async () => {
  const { data } = await instance.patch('merchant/meta/keys');
  return data;
};

/**
 * @param {{ webhook_url: string }} body
 * @returns {Promise<ApiResponse<Object>>}
 */
const updateWebhookUrl = async (body) => {
  const { data } = await instance.patch('merchant/meta/webhook', body);
  return data;
};

/**
 * @param {{ allowed_server_ip: string | null }} body
 * @returns {Promise<ApiResponse<Object>>}
 */
const updateAllowedServerIp = async (body) => {
  const { data } = await instance.patch('merchant/meta/allowed-server-ip', body);
  return data;
};

/**
 * @param {{ allow_underpayment: boolean }} body
 * @returns {Promise<ApiResponse<Object>>}
 */
const updateUnderPaymentToCustomer = async (body) => {
  const { data } = await instance.patch('merchant/meta/allow-underpayment', body);
  return data;
};

/**
 * @param {{ allow_overpayment_refund: boolean }} body
 * @returns {Promise<ApiResponse<Object>>}
 */
const updateOverPaymentToCustomer = async (body) => {
  const { data } = await instance.patch('merchant/meta/allow-overpayment-refund', body);
  return data;
};

/**
 * @param {{ push_fees_to_customer: boolean }} body
 * @returns {Promise<ApiResponse<Object>>}
 */
const updatePushFeesToCustomer = async (body) => {
  const { data } = await instance.patch('merchant/meta/push-fees-to-customer', body);
  return data;
};

/**
 * @param {{ pass_settlement_fee_to_customer: boolean }} body
 * @returns {Promise<ApiResponse<Object>>}
 */
const updatePassSettlementFeeToCustomer = async (body) => {
  const { data } = await instance.patch('merchant/meta/pass-settlement-fee-to-customer', body);
  return data;
};

/**
 * @param {{ auto_payout_enabled: boolean }} body
 * @returns {Promise<ApiResponse<Object>>}
 */
const updateAutoPayoutEnabled = async (body) => {
  const { data } = await instance.patch('merchant/meta/auto-payout-enabled', body);
  return data;
};

/** @returns {Promise<ApiResponse<Object>>} */
const fetchAllowedAutoSettlementCurrencies = async () => {
  const { data } = await instance.get('merchant/meta/allowed-auto-settlement-currencies');
  return data;
};

export {
  fetchAllowedAutoSettlementCurrencies,
  fetchMerchantKeys,
  generateApiKey,
  updateAllowedServerIp,
  updateAutoPayoutEnabled,
  updateOverPaymentToCustomer,
  updatePassSettlementFeeToCustomer,
  updatePushFeesToCustomer,
  updateUnderPaymentToCustomer,
  updateWebhookUrl
};
